import {AfterContentInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ScriptService} from '../../services/mitek/ScriptService';
import {captureDocs, StateIcar, StateMitek} from '../../interfaces/scripts';
import {IcarVisionService} from '../../services/mitek/icar.service';
import {DomSanitizer} from '@angular/platform-browser';
import {MitekService} from '../../services/mitek/mitek.service';
import {DataService} from '../../services/mitek/dataIcar.service';
import {CallService} from '../../services/mitek/call.service';

@Component({
  selector: 'app-mitek',
  templateUrl: './mitek.page.html',
  styleUrls: ['./mitek.page.scss'],
})
export class MitekPage implements OnInit , OnDestroy, AfterContentInit {

  public mensaje = '';
  public activateBoton = true;
  public disabledButtonManual = false;
  public literals = ['capturamos el lado FRONTAL de tu dni', 'capturamos el lado OPUESTO de tu dni', 'capturamos que estas vivo'];

  constructor(
    private icarService: IcarVisionService,
    private mitekService: MitekService,
    private data: DataService,
    private api: CallService,
    private scriptService: ScriptService,
    private sanitizer: DomSanitizer
  ) {
  }

  // variables
  public longData = 0;
  public buttonText = this.literals[this.longData];
  public disabledButton = true;
  public reportVisible = false;
  public dr: any;
  public error: boolean = false;
  public errorTxt: string = '';
  public tipo = 0;

  public step = true;

  // imagenes
  public img1;
  public img2;
  public img3;

  @ViewChild('videoPlayer') videoInput: ElementRef;
  @ViewChild('boton') boton: HTMLButtonElement;

  ngOnInit() {
    //servicios de data

    // estados de Icar
    this.icarService.$IcarServiceState.subscribe(
      menssage => {
        // todo menos el ok
        if (menssage === StateIcar.MANUAL_TRIGER) {
          this.disabledButtonManual = false;
        } else if (menssage === StateIcar.RESULT_OK) {
          this.pintaImagen();
        } else if (menssage === StateIcar.UNKNOWN_ERROR ||
          menssage === StateIcar.NO_CAMERA_DEVICES
        ) {
          this.disabledButton = false;
          alert('error -> en icar');
          // volver al estado origial en la apliacacion final
        }
      });

    // estados de mitek
    this.mitekService.$MitekServiceState.subscribe(
      menssage => {
        if (menssage === StateMitek.ERRORSDK) {
          this.disabledButton = false;
          alert('error -> en mikek');
          // volver al estado origial en la apliacacion final
        } else if (StateMitek.RESULTSDK) {
          this.pintaImagen();
        }
      });
  }

  ngOnDestroy() {
    this.data.$dataServicePush.unsubscribe();
    this.icarService.$IcarServiceState.unsubscribe();
    this.mitekService.$MitekServiceState.unsubscribe();
  }

  ngAfterContentInit() {

    console.log("ngAfterContentInit");

    this.scriptService.load('icarSDK', 'mitekSDK').then(
      () => {
        this.disabledButton = false;
      }
    );
  }

  startVideo() {

    this.disabledButtonManual = true;
    this.disabledButton = true;

    this.tipo = captureDocs.FACE;
    this.mitekService.startVideoFace();

  }

  showReporte() {
    /*
    this.api.senData().subscribe(
      data => {
        this.reportVisible = true;
        this.dr = data;
      },
      (e) => {this.errorTxt = e;this.error = true},
      ()  => console.log("complete")
    )
    */
  }

  pintaImagen() {

    if (this.tipo === captureDocs.DNIFRONT) {
      let data = 'data:image/jpeg;base64,' + this.data.storageData[0];
      //debugger;
      this.mitekService.performQualityCheck(data);
      //TODO: utilizar imagen obtenida por el performQualityCheck (mirar comentario en servicio mitek)
      this.img1 = this.sanitizer.bypassSecurityTrustResourceUrl(data);
    } else if (this.tipo === captureDocs.DNIBACK) {
      let data = 'data:image/jpeg;base64,' + this.data.storageData[1];
      this.mitekService.performQualityCheck(data);
      this.img2 = this.sanitizer.bypassSecurityTrustResourceUrl(data);
    } else {
      //debugger;
      let data = 'data:image/jpeg;base64,' + this.data.storageData[2];
      this.img3 = this.sanitizer.bypassSecurityTrustResourceUrl(data);
    }
  }

  capturaManual() {
    this.icarService.capturaManual();
    this.disabledButtonManual = true;
  }

}
